<template>
    <div
        class="week-timeline d-flex flex-column mx-auto"
        :style="{ minWidth: minWidth }"
    >
        <TimelineHeader :hourBlocks="hourBlocks" />
        <slot></slot>
    </div>
</template>

<script>
import TimelineHeader from "@/components/setting-clinic-hour-v2/week-timeline/week-timeline-header";

const RANGE_BLOCK = 45; // pixel in 1 hour block

export default {
    components: {
        TimelineHeader
    },
    data() {
        return {
            hourBlocks: [
                "12AM",
                "1AM",
                "2AM",
                "3AM",
                "4AM",
                "5AM",
                "6AM",
                "7AM",
                "8AM",
                "9AM",
                "10AM",
                "11AM",
                "12PM",
                "1PM",
                "2PM",
                "3PM",
                "4PM",
                "5PM",
                "6PM",
                "7PM",
                "8PM",
                "9PM",
                "10PM",
                "11PM"
            ]
        };
    },
    computed: {
        rangeBetweenBlock() {
            return RANGE_BLOCK / 60; // pixel per minute
        },
        minWidth() {
            // width first column + width of per minute * 60 minutes * 25 hours (additional 1 hour block space)
            return 175 + this.rangeBetweenBlock * 60 * 25 + "px";
        }
    },
    provide() {
        return {
            rangeBetweenBlock: () => this.rangeBetweenBlock
        };
    }
};
</script>

<style>
.week-timeline .day-timeline-width {
    width: 175px;
    flex-shrink: 0;
}
</style>
